import React, {useMemo} from 'react';
import {boxSettingsProps, USER_FIELDS, USER_SITE_FIELDS} from '../../../../services/ConstHelper';
import { t } from '../../../../services/i18n';
import { useSelector } from 'react-redux';
import usePermissions from "../../../../services/Permissions";
import CheckboxTable from "../../../common/CheckboxTable";
import { getRequiredDefault } from '../../../../services/Helpers';

const RequiredFieldsSettings = ({initialValues, values, setFieldValue, infoTooltip, ...rest}) => {
    const {has} = usePermissions()
    const propName = initialValues?.prop_name;
    let {fields, flows} = useMemo(() => boxSettingsProps[propName] || {}, [propName]);
    flows = flows.filter(flow => {
        if (flow !== 'child') return true;
        if (propName === USER_FIELDS) return has('groupActions');
        if (propName === USER_SITE_FIELDS) return has('allowRegisterGroupMember');
        return true;
    });
    const box = useSelector(state => state.box.box);
    const isGlobal = box?.locations_box[0]?.country_code !== 'IL';

    const isDisabled = (field, flow) => {
        let globalDisabled
        switch (propName) {
            case USER_FIELDS:
                globalDisabled = isGlobal ? ['city.member', 'address.member'] : [];
                return [
                    ...globalDisabled,
                    'first_name.member', 'first_name.lead', 'last_name.member',
                    'source_fk.member', 'users_boxes_owner_id.member', 'personal_id.lead',
                    'first_name.child', 'last_name.child', 'source_fk.child', 'city.child', 'address.child', 'users_boxes_owner_id.child'
                ].includes(`${field}.${flow}`);
            case USER_SITE_FIELDS:
                globalDisabled = isGlobal ? ['personal_id.member', 'personal_id.lead', 'personal_id.child'] : [];
                return [...globalDisabled, 'first_name.member', 'first_name.lead', 'first_name.child', 'last_name.member', 'last_name.lead', 'last_name.child', 'email.child', 'phone.member'].includes(`${field}.${flow}`);
            default:
                return false;
        }
    }

    const isDefaultChecked = (field, flow) => {
        const stored = values.properties?.[field]?.[`${flow}Required`];
        if (stored !== undefined) return stored;
        return getRequiredDefault(field, flow, propName);
    }


    return (
        <CheckboxTable columns={flows}
                       rows={fields}
                       mainColumnName={t('field-name')}
                       isDisabled={isDisabled}
                       isChecked={isDefaultChecked}
                       onChange={(field, flow, checked) => setFieldValue(`properties.${field}.${flow}Required`, checked)}
        />
    );
}

export default RequiredFieldsSettings;